export default "__VITE_ASSET__BXBqp6SU__"